import type { FunctionComponent } from 'preact';

import { names } from 'Addons';
import type { Props as FacetPanelProps } from 'Components/facetPanel/facetPanel';
import { default as FacetPanel } from 'Components/facetPanel/index';
import type { Params as VehicleWidgetParams } from 'Components/fitmentSearch/vehicleWidget/vehicleDropdowns';
import VehicleWidget from 'Components/fitmentSearch/vehicleWidget/vehicleWidget';
import { FacetDialogName, VehicleSpecsName } from 'Components/names';
import SortSelect from 'Components/searchHeader/sortSelect';
import type { TemplateFunction, TemplateResult } from 'Components/types';
import { usePopup } from 'Core/hooks/index';
import { createFitmentSearchExtraFieldsSelector } from 'Core/selectors/fitmentSearch/index';
import { selectedFacetsCountSelector, totalHitsSelector } from 'Core/selectors/search';
import { useSelector } from 'Core/store';

const FacetDialog: FunctionComponent<FacetPanelProps> = (props) => {
  const { opened, close } = usePopup(FacetDialogName);
  const totalHits = useSelector(totalHitsSelector);
  const extraFitmentFields = useSelector(createFitmentSearchExtraFieldsSelector());
  const selectedFacetsCount = useSelector(selectedFacetsCountSelector);

  if (!opened) {
    return null;
  }

  const vehicleSpecs = (template: TemplateFunction<VehicleWidgetParams>) => {
    const vehicleSpecsProps = {
      template,
      name: `${VehicleSpecsName}_facet-dialog`,
      isAlwaysActive: true,
      isAlwaysColumnLayout: true,
      fields: extraFitmentFields,
      columnBreakpoint: undefined, // to avoid TS-JS problem
    };
    return <VehicleWidget {...vehicleSpecsProps} key="facet-dialog-vehicle-specs" />;
  };

  const sortSelect = <SortSelect className="cm_sort-select__dialog" key="sort" />;

  const facetPanelProps = {
    ...props,
    name: FacetDialogName,
    initCollapsed: props.initCollapsed ?? true,
    showAllAlways: true as const,
    extraParams: {
      opened,
      close,
      totalHits,
      vehicleSpecs,
      sortSelect,
      selectedFacetsCount,
      withColorSearch: names.includes('colorSearch'),
    },
  };

  return (<FacetPanel {...facetPanelProps} />) as TemplateResult;
};

export default FacetDialog;
